import React, { useContext, useState } from 'react'
import "./style.scss"
import Shapes from './Shapes/shapes';
import { uploadFileApi } from '../../../../../api';
import { AuthContext } from '../../../../../context/auth';

const Index = ({ setPhotoShapeModal, setSelectedPhotoShape, selectedPhotoShape, setSelectedPhoto, selectedPhoto }) => {
  const { setNotification, setIsLoading } = useContext(AuthContext)

  function cleanFileName(fileName) {
    let x = fileName.replace(/[^a-zA-Z0-9-_\. ]/g, "");
    x = x.replace(/ +/g, " ");
    return x.replace(/ /g, "_");
  }

  return (
    <div className="small-modal-wrapper">
      <div className="small-modal-content" style={{width:'800px'}}>
        <span className='close' onClick={() => {
          if(selectedPhotoShape){
            setPhotoShapeModal(false)
          }else{
            setPhotoShapeModal(false)
            setSelectedPhoto('')
          }
        }}
        ><i className="fas fa-times"></i></span>
        <h2>Select Photo Shape</h2>
          <div className="shapes-container">
            {new Array(12).fill(1).map((_, index) => (
              <Shapes key={index} shapeType={index + 1} style={{ clipPath: `url(#svgPath-${index + 1}-text)`, cursor:'pointer', backgroundImage: `url(${URL.createObjectURL(selectedPhoto) || selectedPhoto})` }}
                onClick={() => {
                  setIsLoading(true)
                  const formData = new FormData();
                  formData.append('files', selectedPhoto, cleanFileName(selectedPhoto.name));
                  uploadFileApi(formData).then((res) => {
                    if (res && res.data) {
                      setSelectedPhoto(res?.data?.uploads[0]?.url)
                      setSelectedPhotoShape(index + 1)
                      setPhotoShapeModal(false)
                      setIsLoading(false)
                      setNotification({
                        message: "Image Uploaded Successfully",
                        type: "green"
                      })
                    }
                  }).catch((err) => {
                    setNotification({
                      message: "Something went wrong",
                      type: "red"
                    })
                    setIsLoading(false)
                  })
                }}
              />
            ))}
          </div>
        <button className='btn transparent' onClick={() => {
            if(selectedPhotoShape){
              setPhotoShapeModal(false)
            }else{
              setPhotoShapeModal(false)
              setSelectedPhoto('')
            }
        }}>Cancel</button>
      </div>
    </div>
  )
}

export default Index